<template>
  <!-- 招聘 -->
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span>首页</span>
        <span>></span>
        <span>招聘</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="privacy">
            <p>
              <strong>1.新媒体实习生</strong>
            </p>
            <p>你对商业世界有足够的好奇心吗？</p>
            <p>你愿意将自己对于热点新闻的解读第一时间通过《第一财经杂志》新媒体平台传递给广大读者吗？</p>
            <p>如果你对此有兴趣并且具备以下这些特点：</p>
            <p>
              <strong>好奇：</strong>对商业世界的事件有探索欲
            </p>
            <p>
              <strong>有趣：</strong>会不停地有新奇的点子并知道如何打动读者
            </p>
            <p>
              <strong>勤勉：</strong>手快并且文采也不错
            </p>
            <p>
              <strong>自律：</strong>我们不坐班，但得按时交稿
            </p>
            <p>
              <strong>工作地点：</strong>有电脑和网络的地方（当然如果你在上海就更好了）
            </p>
            <p>
              请将简历和作品发送至：
              <strong>zhanglei@yicai.com</strong>同时欢迎谈谈你对新媒体传播的想法。
            </p>
            <p>
              <strong>2.记者</strong>
            </p>
            <p>
              <strong>（工作地点：北京&上海）</strong>
            </p>
            <p>
              <strong>-岗位要求-</strong>
            </p>
            <p>01.对商业现象及其背后的逻辑兴趣浓厚</p>
            <p>02.专注，有快速学习能力，英文也不赖</p>
            <p>03.文字功底及平日阅读，能支撑你写一个好故事</p>
            <p>04.爱生活，爱吐槽，爱新奇的一切</p>
            <p>05.周刊粉丝、在金融或地产领域有采写经验者会受到优先对待</p>
            <p>
              以上岗位请发简历至
              <strong>xuru@yicai.com</strong>
            </p>
          </div>
        </div>
        <div class="content-r">
          <Wechart></Wechart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wechart from "@/components/wechart";
import { getTdkList} from "@/api/tdk";
export default {
  components: {
    Wechart
  },
  data() {
    return {};
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  span:last-child {
    color: #0091ff;
  }
}
.privacy {
  padding: 30px;
  background: #ffffff;
  margin-bottom: 60px;
  text-align: justify;
  p {
    font-size: 16px;
    margin-bottom: 10px;
    line-height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/footer/recruit.vue